var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F14937",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F14937",
  d: "M5.122 19H4l1.457-4h1.39l1.456 4H7.182l-1.015-2.992h-.033zm-.15-1.574h2.345v.734H4.972zM9.763 15l.965 2.93h.036L11.73 15h1.168l-1.457 4h-1.39l-1.457-4zM15 15v4h-1.044v-4z"
})));
export default SvgAvi;